import React, { useContext, useEffect } from "react";
import { Form } from "react-bootstrap";
import Cart_details_card from "../../common_components/cart_details_card/Cart_details_card";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { useNavigate } from "react-router-dom";
import Summery_holder from "../summery_holder/Summery_holder";
import { getCartLuxury } from "../../../utils/luxuryapis/addToCart/addToCart";
import { useState } from "react";
import { Context } from "../../../utils/context";

function Step_1({ setActiveStep, setCheckoutStep, cartData, getAllData }) {
  const navigate = useNavigate();
  const { IMG_URL, signin } = useContext(Context);

  return (
    <>
      <section className="cart_step_content">
        {cartData?.data?.length > 0 ? (
          <div className="row">
            <div className="col-md-8">
              <div className="content_box_holder mt-3">
                <div className="heading_strip_holder">
                  <div className="content_strip_holder">
                    <div>
                      <h1>
                        You have {cartData?.data?.length} items in your cart.
                      </h1>
                    </div>
                  </div>
                  <hr />
                </div>

                <div>
                  {cartData?.data?.map((val) => (
                    <Cart_details_card
                      data={val}
                      IMG_URL={IMG_URL}
                      getAllData={getAllData}
                    />
                  ))}
                </div>

                <div className="heading_strip_holder">
                  <div className="content_strip_holder">
                    <h1>Subtotal</h1>
                    <h1>₹ {Number(cartData?.total_selling).toFixed(2)}</h1>
                  </div>
                  <hr />
                </div>

                <div className="heading_strip_holder">
                  <div className="content_strip_holder">
                    <div>
                      <h1>Shipping</h1>
                      <p>Shipping costs will be calculated during checkout</p>
                    </div>
                  </div>
                  <hr />
                </div>

                <div className="heading_strip_holder">
                  <div className="content_strip_holder">
                    <div>
                      <h1>Taxes</h1>
                      <p>Shipping costs will be calculated during checkout</p>
                    </div>
                  </div>
                  <hr />
                </div>

                <div className="heading_strip_holder">
                  <div className="content_strip_holder">
                    <h1>Total</h1>
                    <h1>₹ {Number(cartData?.total_selling).toFixed(2)}</h1>
                  </div>
                  <hr />
                </div>
              </div>

              {/* <div className="content_box_holder mt-3">
              <div className="heading_strip_holder">
                <div className="content_strip_holder">
                  <h1>Gifting</h1>
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" />
                  </Form.Group>
                </div>
              </div>
            </div> */}

              <div className="content_box_holder mt-3">
                <div className="btn_holder">
                  <Purple_Btn
                    btnText="Continue Shopping"
                    onClick={() => navigate("/luxury/products")}
                  />

                  {/* GO TO STEP 2 */}
                  <Purple_Btn
                    btnText="Checkout"
                    onClick={() => {
                      if (signin) {
                        setActiveStep(2);
                        setCheckoutStep(2);
                      } else {
                        navigate(`/login`);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-md-4">
              <Summery_holder cartData={cartData} />
            </div>
            {/* END RIGHT SIDE */}
          </div>
        ) : (
          <div className="empty-cart text-center py-5">
            <i className="fa-solid fa-basket-shopping empty-cart-icon"></i>
            <h4 className="mt-3">Your Cart is Empty</h4>
            <p>Add some products to your cart to continue shopping.</p>
          </div>
        )}
      </section>
    </>
  );
}

export default Step_1;
